import React from 'react'
import Content from '../../../Components/Dashboard/Content/Content'
export default function Optionchain() {
    return (
        <Content>
            <div>
                HI
            </div>
        </Content>
    )
}
